
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 8h1a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1V9a1 1 0 011-1h1V7a7 7 0 0114 0v1zM2 10v8h14v-8H2zm6 2h2v4H8v-4zm6-4V7A5 5 0 004 7v1h10z","fill":"#FAAD14"}})])
          )
        }
      }
    